import { type ReactNode } from 'react';

// Единая отрисовка «грузим / упало / пусто» для всех вьюх админки: без неё каждая страница
// изобретает свой вид ошибки, и мы теряем главное - текст, который реально помогает чинить.

export function QueryState({
  isLoading,
  error,
  isEmpty,
  emptyText = 'Пусто',
  children,
}: {
  isLoading: boolean;
  error: unknown;
  isEmpty?: boolean;
  emptyText?: string;
  children: ReactNode;
}) {
  if (isLoading) return <div className="p-4 text-sm text-muted">Загружаем…</div>;
  if (error) {
    return (
      <div
        role="alert"
        className="rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive"
      >
        {error instanceof Error ? error.message : 'Не удалось загрузить данные'}
      </div>
    );
  }
  if (isEmpty) return <div className="p-4 text-sm text-muted">{emptyText}</div>;
  return <>{children}</>;
}
